
document.querySelectorAll('details[is="mega-menu-disclosure"]').forEach((details) => {
    const summary = details.querySelector('summary');
    const megaMenu = details.querySelector('.mega-menu');
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  
    details.addEventListener('toggle', () => {
      if (details.open) {
        megaMenu.style.opacity = '1';
        summary.setAttribute('aria-expanded', 'true');
      } else {
        megaMenu.style.opacity = '0';
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });

  $(document).on('keydown', '.mega-menu__nav a', function(e) {
    if (e.key === 'Escape') {
      const $details = $(this).closest('details[is="mega-menu-disclosure"]');
      const $trigger = $details.find('summary');
  
      // Collapse the menu (optional)
      $details.removeAttr('open').attr('aria-expanded', 'false');
      $trigger.attr('aria-expanded', 'false');
  
      // Move focus back to the trigger
      $trigger.focus();
    }
  });
  


$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
      var phoneNumber = $(this).attr('href').replace('tel:', '');
      $(this).attr('aria-label', 'Phone number ' + phoneNumber + ', this link will open in a new tab');
      $(this).attr('target', '_blank');
      $(this).attr('rel', 'noreferrer noopener');
      $('a[href="mailto:Hello@Footprintusa.co"]').attr('aria-label', 'Email hello@footprint usa.co this link will open in new window');
      
  });
});


$(document).ready(function() {
  $('br').attr('aria-hidden', 'true');
  $('.station-tabs-tabcontent h3').remove();
$(' h2, h3, h4, h5, h6').each(function () {
  if ($(this).text().trim() === '') {
    $(this).remove();
  }
});
});


$(document).ready(function() {
  const targetParagraph = $('.rich-text .prose p.h1');
  if (targetParagraph.length) {
    const content = targetParagraph.html();
    targetParagraph.replaceWith(`<h1 class="h1 hyphenate">${content}</h1>`);
  }
});



// Find all link elements with class 'text-with-icon'
const links = document.querySelectorAll('a.text-with-icon');

links.forEach(link => {
  let uniqueText = '';
  if (link.getAttribute('href')) {
    uniqueText = link.getAttribute('href')
      .split('/').pop()          
      .replace(/-/g, ' ')       
      .replace(/\b\w/g, c => c.toUpperCase()); 
  }
  if (uniqueText) {
    link.setAttribute('aria-label', `View all ${uniqueText}`);
    console.log('Updated aria-label for link:', link.getAttribute('aria-label'));
  }
});


$(document).on('keydown', function (e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    $('details[open]').each(function () {
      $(this).removeAttr('open');
      $(this).attr('aria-expanded', 'false');
    });
  }
});

$(document).ready(function () {
  const $input = $('input[type="search"]');
  const $clearBtn = $('button[type="reset"]');

  function toggleClearBtn() {
    if ($input.val().trim() !== '') {
      $clearBtn.show();
    } else {
      $clearBtn.hide();
    }
  }

  toggleClearBtn();

  $input.on('input', toggleClearBtn);

  $clearBtn.on('click', function () {
    $input.focus();
    toggleClearBtn();
  });

  const observer = new MutationObserver(function () {
    toggleClearBtn();
  });

  const drawer = document.querySelector('#search-drawer');
  if (drawer) {
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
});

$(document).ready(function () {
  $('.product-card__figure').hover(
    function () {
      // On mouse enter: show secondary image
      $(this).find('.product-card__image--secondary').css('display', 'block');
    },
    function () {
      // On mouse leave: hide secondary image
      $(this).find('.product-card__image--secondary').css('display', 'none');
    }
  );
});

$('.sr-only').each(function () {
  const text = $(this).text().trim();
  if (text === 'Previous' || text === 'Next') {
    $(this).text(text + ' Slide');
  }
});

$('.product-info__description .sc-afccd88e-2 > h5').each(function () {
  const $h2 = $('<h2>', {
    html: $(this).html(),
    class: $(this).attr('class'),
    'data-component': 'H2'
  });
  $(this).replaceWith($h2);
});


$(document).ready(function () {
  $('.mobile-menu').on('click', function () {
    setTimeout(function () {
        $('#mobile-focus').focus();
    }, 1000);
});

});
document.querySelectorAll('a[role="tab"]').forEach(function(el) {
  el.removeAttribute('role');
});


//
$('.panel-list__wrapper').on('click', 'button', function () {
  var clickedButton = $(this);
  var clickedText = clickedButton.text().trim();
  setTimeout(function () {
      var matches = [];
      var clickedIndex = -1;
      $('.panel-list__wrapper button').each(function () {
          if ($(this).text().trim() === clickedText) {
              matches.push(this);
              if (this === clickedButton[0]) {
                  clickedIndex = matches.length - 1;
              }
          }
      });
      if (matches.length > 1) {
          var nextIndex = (clickedIndex + 1) % matches.length;
          $(matches[nextIndex]).focus();
      }
  }, 1000); 
});
